var _excluded = ["chevron", "children", "className", "collapseIcon", "expandIcon", "onBlur", "onClick", "onFocus", "onKeyDown"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import PropTypes from "prop-types";
import React, { forwardRef, useContext } from "react";
import AAccordionContext from "./AAccordionContext";
import AAccordionPanelContext from "./AAccordionPanelContext";
import { keyCodes } from "../../utils/helpers";
import "./AAccordion.scss";
import AIcon from "../AIcon";
var AAccordionHeaderTitle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$chevron = _ref.chevron,
    chevron = _ref$chevron === void 0 ? true : _ref$chevron,
    children = _ref.children,
    propsClassName = _ref.className,
    _ref$collapseIcon = _ref.collapseIcon,
    collapseIcon = _ref$collapseIcon === void 0 ? "caret-up" : _ref$collapseIcon,
    _ref$expandIcon = _ref.expandIcon,
    expandIcon = _ref$expandIcon === void 0 ? "caret-down" : _ref$expandIcon,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(AAccordionPanelContext),
    panelId = _useContext.panelId,
    setIsFocused = _useContext.setIsFocused,
    hasBody = _useContext.hasBody,
    panelKey = _useContext.panelKey,
    isCollapsed = _useContext.isCollapsed,
    onToggle = _useContext.onToggle;
  var _useContext2 = useContext(AAccordionContext),
    openedPanels = _useContext2.openedPanels,
    setOpenedPanels = _useContext2.setOpenedPanels;
  var togglePanel = function togglePanel() {
    if (openedPanels.includes(panelId)) {
      setOpenedPanels(openedPanels.filter(function (x) {
        return x !== panelId;
      }));
    } else {
      setOpenedPanels([].concat(_toConsumableArray(openedPanels), [panelId]));
    }
    onToggle && onToggle(panelKey);
  };
  var handleClick = function handleClick(e) {
    hasBody && togglePanel();
    onClick && onClick(e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (hasBody && [keyCodes.enter, keyCodes.space].includes(e.keyCode)) {
      e.preventDefault();
      togglePanel();
    }
    onKeyDown && onKeyDown(e);
  };
  var handleBlur = function handleBlur(e) {
    hasBody && setIsFocused(false);
    onBlur && onBlur(e);
  };
  var handleFocus = function handleFocus(e) {
    hasBody && setIsFocused(true);
    onFocus && onFocus(e);
  };
  var className = "a-accordion__link",
    chevronClassName = "a-accordion__chevron";
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }
  var chevronIcon = panelKey && isCollapsed || !panelKey && !openedPanels.includes(panelId) ? expandIcon : collapseIcon;
  var props = {};
  if (hasBody) {
    props.tabIndex = 0;
    props.role = "button";
  }
  return (
    /*#__PURE__*/
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, rest, props, {
      onBlur: handleBlur,
      onClick: handleClick,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      ref: ref,
      className: className
    }), children), chevron && /*#__PURE__*/React.createElement("div", {
      onBlur: handleBlur,
      onClick: handleClick,
      onFocus: handleFocus,
      onKeyDown: handleKeyDown,
      className: chevronClassName
    }, /*#__PURE__*/React.createElement(AIcon, {
      size: 12
    }, chevronIcon)))
    /* eslint-enable jsx-a11y/no-static-element-interactions */
  );
});

AAccordionHeaderTitle.defaultProps = {
  chevron: true
};
AAccordionHeaderTitle.propTypes = {
  /**
   * Toggles the chevron.
   */
  chevron: PropTypes.bool,
  /**
   * Sets an alternative collapse icon.
   */
  collapseIcon: PropTypes.string,
  /**
   * Sets an alternative expand icon.
   */
  expandIcon: PropTypes.string
};
AAccordionHeaderTitle.displayName = "AAccordionHeaderTitle";
export default AAccordionHeaderTitle;